"use client";
import * as React from "react";
import Image from "next/image";
import WorldMap from "../../../../public/country-map.jpg";

const Map = () => {
  return (
    <div className="-mt-10">
      <div className="container">
        <div className="flex justify-center">
          <Image
            src={WorldMap}
            alt="map"
            className="relative"
            useMap="#image-map"
            loading="lazy"
          />
        </div>
        <map name="image-map">
          <area
            alt="India"
            title="India"
            href="/distributor/in"
            coords="809,436,817,397,851,430,830,475,831,465,833,471,823,449"
            shape="poly"
          />
          <area
            alt="Nepal"
            title="Nepal"
            href="/distributor/np"
            coords="848,402,13"
            shape="circle"
          />
          <area
            alt="Bangladesh"
            title="Bangladesh"
            href="/distributor/bd"
            coords="875,418,13"
            shape="circle"
          />
          <area
            alt="Sri Lanka"
            title="Sri Lanka"
            href="/distributor/lk"
            coords="844,495,15"
            shape="circle"
          />
          <area
            alt="Thailand"
            title="Thailand"
            href="/distributor/th"
            coords="918,458,13"
            shape="circle"
          />
          <area
            alt="Vietnam"
            title="Vietnam"
            href="/distributor/vn"
            coords="951,467,15"
            shape="circle"
          />
          <area
            alt="Malaysia"
            title="Malaysia"
            href="/distributor/my"
            coords="911,488,13"
            shape="circle"
          />
          <area
            alt="Singapore"
            title="Singapore"
            href="/distributor/sg"
            coords="933,498,13"
            shape="circle"
          />
          <area
            alt="Bahrain"
            title="Bahrain"
            href="/distributor/bh"
            coords="710,409,12"
            shape="circle"
          />
          <area
            alt="Qatar"
            title="Qatar"
            href="/distributor/qa"
            coords="738,433,15"
            shape="circle"
          />
          <area
            alt="Germany"
            title="Germany"
            href="/distributor/de"
            coords="584,314,19"
            shape="circle"
          />
          <area
            alt="UK"
            title="UK"
            href="/distributor/uk"
            coords="535,285,16"
            shape="circle"
          />
          <area
            alt="France"
            title="France"
            href="/distributor/fr"
            coords="558,337,9"
            shape="circle"
          />
          <area
            alt="Tunisia"
            title="Tunisia"
            href="/distributor/tn"
            coords="586,386,11"
            shape="circle"
          />
          <area
            alt="Uganda"
            title="Uganda"
            href="/distributor/ug"
            coords="669,502,16"
            shape="circle"
          />
          <area
            alt="Kenya"
            title="Kenya"
            href="/distributor/ke"
            coords="697,518,10"
            shape="circle"
          />
          <area
            alt="Tanzania"
            title="Tanzania"
            href="/distributor/tz"
            coords="672,540,11"
            shape="circle"
          />
          <area
            alt="Zambia"
            title="Zambia"
            href="/distributor/zm"
            coords="652,572,10"
            shape="circle"
          />
          <area
            alt="Ghana"
            title="Ghana"
            href="/distributor/gh"
            coords="552,495,12"
            shape="circle"
          />
          <area
            alt="Nigeria"
            title="Nigeria"
            href="/distributor/ng"
            coords="573,482,13"
            shape="circle"
          />
          <area
            alt="South Africa"
            title="South Africa"
            href="/distributor/za"
            coords="613,634,14"
            shape="circle"
          />
          <area
            alt="Colombia"
            title="Colombia"
            href="/distributor/co"
            coords="308,510,14"
            shape="circle"
          />
          <area
            alt="Brazil"
            title="Brazil"
            href="/distributor/br"
            coords="405,569,16"
            shape="circle"
          />
          <area
            alt="US"
            title="US"
            href="/distributor/us"
            coords="257,370,23"
            shape="circle"
          />
          <area
            alt="Canada"
            title="Canada"
            href="/distributor/ca"
            coords="195,280,231,300"
            shape="rect"
          />
          <area
            alt="Saudi Arabia"
            title="Saudi Arabia"
            href="/distributor/sa"
            coords="694,429,715,434,715,459,696,447"
            shape="poly"
          />
        </map>

        <style jsx>{`
          .popup {
            position: absolute;
            background-color: white;
            border: 1px solid gray;
            padding: 10px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            z-index: 10;
          }
        `}</style>
      </div>
    </div>
  );
};

export default Map;
